<template>
  <div class="contact-inner">
    <div class="inner-header">
      <img src="@/assets/img/logo.svg" class="logo" />
      <span>打卡森林 | 帮你养成好习惯</span>
      <span class="desc" @click="onClickMain()">产品介绍</span>
      <span class="contact">联系我们</span>
    </div>
    <el-divider style="margin:0;"></el-divider>
        <div class="content">
北京链生长科技有限公司
简称：链生长。 链生长是一家移动应用软件开发公司。公司致力于为用户提供数字化服务。公司研发
出打卡森林、海豚计算器等移动APP。

任何合作或者建议问题请联系我们。

邮箱：dakasenlin@126.com
    </div>
    <div class="inner-footer">
      <span class="footer1">© 2021 fbee.site, all rights reserved    京ICP备18035449号</span>
      <a href="https://prdimages.growup.link/forestConfig/senlin_privacyPolicy.html" target="_blank" >隐私政策</a>
      <span style="margin-left:10px;margin-right:10px;">|</span>
      <a href="https://prdimages.growup.link/forestConfig/senlin_userAgreement.html" target="_blank" >用户协议</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Contact',
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    onClickMain () {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang='scss'>

.contact-inner {
  min-width: 1440px;
  height: 100%;
  display: flex !important;
  flex-direction: column;
  margin-left: auto;
  margin-right: auto;
  align-items: center;

  .inner-header {
    height: 40px;
    width: 1010px;
    display: flex;
    color: #000;
    align-items: center;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 26px;
    user-select: none;

    .logo {
      width: 40px;
      height: 40px;
      margin-right: 20px;
      align-items: center;
    }

    .desc {
      cursor: pointer;
      margin-right: 0px;
      margin-left: auto;
    }

    .contact {
      cursor: pointer;
      margin-right: 0px;
      margin-left: 78px;
      font-weight: bold;
    }
  }

  .el-divider--horizontal {
    margin: 0;
  }

  .content {
    width: 1014px;
    font-size: 20px;
    line-height: 40px;
    word-break: break-all;
    white-space: pre-wrap;
  }

  .inner-footer {
    display: flex;
    color: #000;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    margin-top: auto;
    margin-bottom: 30px;

    .footer1 {
      text-align: center;
      width: 445px;
    }

    a {
      color: #000;
      text-decoration: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/page/Contact.vue